import axios from 'axios';
export class S3Service {
    constructor( url ) { this.url = url }
    async upload(file, fields) {
        const formData = new FormData()
        for (let key in fields) {
            formData.append(key, fields[key])
        }
        formData.append('file', file)
        return await axios.post(this.url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    }
}